import { __ } from '@wordpress/i18n';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import ControlManager from './control-manager';

const modalRoot = document.body;


const TemplateForm = ({ isOpen, onClose, onSubmit, menuTitle, data, activeMenu }) => {

  const { conditionFields } = window['JkitDashboardOption'];
  const fieldsList = (activeMenu === 'jkit-header' || activeMenu === 'jkit-footer') ? conditionFields.default : conditionFields[activeMenu];
  const [defualtValue, setDefaultValue] = useState({});
  useEffect(() => {
    let def = {};
    Object.entries(fieldsList).forEach(([key, value]) => {
      if (value.default && value.default !== '') {
        def[key] = value.default;
      }
    });
    setDefaultValue(def)
  }, [activeMenu]);


  const [title, setTitle] = useState(data?.title || menuTitle + ' Title')
  const [error, setError] = useState(false)
  const [condition, setCondition] = useState(data?.condition || [])
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  function addCondition() {
    setCondition(
      [...condition,
        defualtValue,
      ]
    )
  }



  function removeCondition(index) {
    setCondition(
      condition.filter((item, key) => key !== index)
    );
  }

  function handleSubmit() {
    if (title.length > 0) {
      if (data) {
        onSubmit({
          id: data.id,
          title: title,
          condition: condition
        })
      } else {
        onSubmit({
          title: title,
          condition: condition
        })
      }
      setTitle(data?.title || menuTitle + ' Title');
      setCondition(data?.condition || []);
    } else {
      setError(true);
    }
  }



  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className='jkit-dashboard-popup-overlay'>
      <div className='jkit-popup-content'>
        <div className='jkit-popup-header'>
          <h3>{data ? `Edit ${menuTitle} Template` : `Create ${menuTitle} Template`}</h3>
          <div className='jkit-icon-button fill' onClick={() => onClose()}>
            <CloseIcon />
          </div>
        </div>
        <div className='jkit-popup-body'>
          <div className={error ? 'jkit-control jkit-text jkit-error' : 'jkit-control jkit-text'}>
            <h3 className='control-label'>{__('Template Title', 'jeg-elementor-kit')}</h3>
            <input
              value={title}
              onChange={(e) => { setTitle(e.target.value); }}
              type="text"
              name='title'
              placeholder={`${menuTitle} Template`}
              className="control-text"
            />
            <p className='control-desc'>{error ? __('Add your the template title first.', 'jeg-elementor-kit') : __('Add your the template title here.', 'jeg-elementor-kit')}</p>
          </div>

          {condition.length === 0 ?
            <div className='add-condition-wrapper'>
              <h3>{__('Create filter condition', 'jeg-elementor-kit')}</h3>
              <p>{__('Create filter where your ', 'jeg-elementor-kit') + menuTitle + __(' will be shown, leave empty to show it everywhere.', 'jeg-elementor-kit')} </p>
            </div>
            :
            condition.map((item, index) => (
              <ConditionFields key={activeMenu + index} index={index} values={condition[index]} removeCondition={removeCondition} setCondition={setCondition} data={data} fieldsList={fieldsList} defualtValue={defualtValue} />
            ))}
          <button className='add-condition-button' onClick={() => addCondition()}>
            <span>+</span>
            {__('Add Condition', 'jeg-elementor-kit')}</button>

        </div>
        <div className='jkit-popup-footer'>
          <button className='jkit-primary-button' type="button" onClick={handleSubmit}>{data ? __('Update Template', 'jeg-elementor-kit') : __('Create Template', 'jeg-elementor-kit')}</button>
        </div>
      </div>
    </div>,
    modalRoot
  );
};



function ConditionFields({ index, values, removeCondition, setCondition, data, fieldsList, defualtValue }) {
  function updateValue(id, val) {

    setCondition((prev) => {
      let newCond = [...prev];

      const merged = Object.fromEntries(
        Object.entries(newCond[index]).map(([key, val]) => [
          key,
          val === '' ? (defualtValue[key] ?? '') : val
        ])
      );

      newCond[index] = {
        ...merged,
        [id]: val
      };

      return newCond;
    });
  }

  function checkDefaultOpen() {
    if (data.condition) {
      return index >= data.condition.length;
    }

    return true;
  }



  const [open, setOpen] = useState(data ? checkDefaultOpen() : false);

  return (

    <div className='jkit-control jkit-repeater'>
      <div className={`repeater-header ${open ? ' open' : ''}`}>
        <div className='header-label' onClick={() => setOpen(!open)}>
          <ArrowIcon />
          {`Condition ${index + 1}`}
        </div>
        <div className='remove-butotn' onClick={() => removeCondition(index)} >
          <RemoveIcon />
        </div>
      </div>
      {open && <div className='repeater-body'>
        {Object.entries(fieldsList).map(([key, fields]) =>
          <ControlManager
            key={key}
            id={key}
            fields={fields}
            values={values}
            updateValue={updateValue}
            fieldsList={fieldsList}
          />
        )}
      </div>}

    </div>
  )
}

const CloseIcon = () => {
  return (
    <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.53683 6.83573L6.52349 5.84907C6.61119 5.76137 6.69695 5.75942 6.78075 5.84322L17.843 16.9055C17.9268 16.9893 17.9249 17.0751 17.8372 17.1628L16.8505 18.1494C16.7628 18.2371 16.6771 18.2391 16.5933 18.1553L5.53098 7.09299C5.44718 7.00919 5.44913 6.92343 5.53683 6.83573Z" fill="#7D8292" />
      <path d="M5.56417 16.9285L16.6148 5.87791C16.7025 5.7902 16.7882 5.78825 16.872 5.87206L17.8148 6.81487C17.8986 6.89867 17.8967 6.98443 17.809 7.07213L6.7584 18.1227C6.67069 18.2104 6.58494 18.2124 6.50113 18.1286L5.55833 17.1858C5.47452 17.102 5.47647 17.0162 5.56417 16.9285Z" fill="#7D8292" />
    </svg>

  );
}

const RemoveIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M12 4.5V3.9C12 3.05992 12 2.63988 11.8365 2.31901C11.6927 2.03677 11.4632 1.8073 11.181 1.66349C10.8601 1.5 10.4401 1.5 9.6 1.5H8.4C7.55992 1.5 7.13988 1.5 6.81901 1.66349C6.53677 1.8073 6.3073 2.03677 6.16349 2.31901C6 2.63988 6 3.05992 6 3.9V4.5M7.5 8.625V12.375M10.5 8.625V12.375M2.25 4.5H15.75M14.25 4.5V12.9C14.25 14.1601 14.25 14.7902 14.0048 15.2715C13.789 15.6948 13.4448 16.0391 13.0215 16.2548C12.5402 16.5 11.9101 16.5 10.65 16.5H7.35C6.08988 16.5 5.45982 16.5 4.97852 16.2548C4.55516 16.0391 4.21095 15.6948 3.99524 15.2715C3.75 14.7902 3.75 14.1601 3.75 12.9V4.5" stroke="#3B3B3E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  );
}

const ArrowIcon = () => {
  return (
    <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.7941 0.733184C11.9312 0.877226 12.0054 1.0698 12.0006 1.26857C11.9957 1.46733 11.9121 1.65603 11.7681 1.79318L6.51812 6.79418C6.37864 6.92715 6.19333 7.00133 6.00062 7.00133C5.80791 7.00133 5.6226 6.92715 5.48312 6.79418L0.233121 1.79418C0.0889755 1.65707 0.00520408 1.4683 0.000234363 1.26942C-0.00473535 1.07054 0.069504 0.877829 0.206621 0.733684C0.343738 0.589539 0.5325 0.505767 0.731383 0.500797C0.930265 0.495827 1.12298 0.570067 1.26712 0.707184L6.00112 5.21618L10.7341 0.706184C10.8783 0.569255 11.0709 0.49518 11.2697 0.500243C11.4685 0.505306 11.6571 0.589093 11.7941 0.733184Z" fill="#1C2124" />
    </svg>
  );
}

export default TemplateForm;
